import { render, staticRenderFns } from "./AttachmentDeleteDialog.vue?vue&type=template&id=7c640b0c"
import script from "./AttachmentDeleteDialog.vue?vue&type=script&lang=js"
export * from "./AttachmentDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports